import { FC } from "react";

export const Form: FC<React.PropsWithChildren> = (props) => {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
            }}
        >
            {props.children}
        </form>
    );
};